import React from 'react';
import './PageHeader.css';
import logo from '../../img/logo.png'

export default function PageHeader(props) {
    const getPageLink = () => {
        switch (props.page) {
            case "work":
                return <a href={ process.env.PUBLIC_URL + "/#/about" }>About</a>
            case "about":
                return <a href={ process.env.PUBLIC_URL + "/#/work" }>Work</a>
            case "contact":
                return <a href={ process.env.PUBLIC_URL + "/#/work" }>Work</a>
            default:
                return;
        }
    }
    return (
        <header>
            <div className="page-header header-divider">
                <figure>
                    <a href={ process.env.PUBLIC_URL + "/#/" }><img src={ logo } alt="A.Bowler" /></a>
                </figure>

                <nav>
                    <ul>
                        <li><a href={ process.env.PUBLIC_URL + "/#/" }>Home</a></li>
                        <li>{ getPageLink() }</li>
                        <li>
                            { props.page !== "contact" 
                                ? <a href={ process.env.PUBLIC_URL + "/#/contact" }>Contact</a> 
                                : <a href={ process.env.PUBLIC_URL + "/#/about" }>About</a>
                            }
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    )
}